import(/* webpackMode: "eager" */ "/home/jubalj/builds/babyportal/apps/neocare-next/src/app/error.tsx");
